module.exports = __webpack_public_path__ + "static/media/WG.2841f80c.png";